import { computed, ref } from 'vue';
import { defineStore } from 'pinia';
import { useTheme } from 'vuetify';

export type SidebarConfig = {
  rail?: boolean;
  visible: boolean;
  permanent: boolean;
};

export const useAppConfigStore = defineStore(
  'appConfig',
  () => {
    const theme = useTheme();

    const sidebarConfig = ref<SidebarConfig>({
      rail: false,
      visible: true,
      permanent: true
    });
    const currentTheme = ref<'light' | 'dark'>('light');

    const menuCollapsed = computed(() =>
      !sidebarConfig.value.permanent ? undefined : sidebarConfig.value.rail
    );

    const sidebarPermanent = computed(() => (sidebarConfig.value.permanent ? true : undefined));

    const sidebarTemporary = computed(() => (!sidebarConfig.value.permanent ? true : undefined));

    function setTheme(colorScheme: 'light' | 'dark'): void {
      currentTheme.value = colorScheme;
      theme.global.name.value = currentTheme.value;
    }

    function checkAndSetTheme(): void {
      if (theme.global.name.value !== currentTheme.value) {
        theme.global.name.value = currentTheme.value;
      }
    }

    function setSidebarConfig(config: Partial<SidebarConfig>): void {
      sidebarConfig.value = { ...sidebarConfig.value, ...config };
    }

    return {
      currentTheme,
      sidebarConfig,
      menuCollapsed,
      sidebarPermanent,
      sidebarTemporary,
      setSidebarConfig,
      checkAndSetTheme,
      setTheme
    };
  },
  { persist: true }
);
